// Book Away circular brand mark — official finalized logo.
import logoSrc from "@/assets/book-away-logo.png";

export const Logo = ({ size = 46, className = "" }) => (
  <img
    src={logoSrc}
    width={size}
    height={size}
    alt="Book Away"
    className={className}
    style={{ width: size, height: size, objectFit: "contain" }}
  />
);

export default Logo;
